export const eventCacheSchema = {
    title: 'Dashboard Event Cache Schema',
    version: 0,
    description: 'Describes a dashboard event cache schema',
    primaryKey: 'topic',
    type: 'object',
    properties: {
        id: {
            type: 'string',
            maxLength: 100, // <- the primary key must have set maxLength
        },
        topic: {
            type: 'string',
            maxLength: 500, // <- the primary key must have set maxLength
        },
        evt: {
            type: 'object',
            properties: {
                name: {
                    type: 'string',
                },
                payload: {
                    type: 'object',
                },
            },
            required: ['name'],
        },
    },
    required: ['id', 'topic', 'evt'],
};

export const dashboardCacheSchema = {
    title: 'Dashboard Cache Schema',
    version: 1,
    description: 'Describes a dashboard cache schema',
    primaryKey: 'id',
    type: 'object',
    properties: {
        id: {
            type: 'string',
            maxLength: 100, // <- the primary key must have set maxLength
        },
        userId: {
            type: 'string',
            description: 'The user id this cache relates to',
        },
        dashboardId: {
            type: 'string',
            description: 'The dashboard id this cache relates to',
        },
        cache: {
            type: 'object',
            description: 'The cha',
        },
        migratedFromPouchDB: {
            type: 'boolean',
            description: 'Indicates if the cache has been migrated from pouchdb',
        },
    },
    required: ['id', 'cache'],
};
